export enum REPORTING_TYPE_ENUM {
  REPORTING_TYPE_FTR = 'For The Record (FTR)',
  REPORTING_TYPE_REPORTER_STUDIO_PRO_SINGLECHANNEL = 'Reporter Studio Pro (Single Channel .mp3)',
  REPORTING_TYPE_REPORTER_STUDIO_PRO_MULTICHANNEL = 'Reporter Studio Pro (Multichannel Channel .mp3)',
  REPORTING_TYPE_ZOOM_MULTICHANNEL = 'Zoom Multichannel',
  REPORTING_TYPE_OTHER_MP3_MULTICHANNEL = 'Other .mp3 Multichannel',
  REPORTING_TYPE_OTHER_MP3_SINGLECHANNEL = 'Other .mp3 Single Channel',
  REPORTING_TYPE_OTHER = 'Other',
}
